export default __webpack_public_path__ + "5b0d21d5bd577450745a5423c61d8d62.png";